**Info. Ratio** measures the risk-adjusted return of an index (average
return earned per standard deviation).
